<template>
  <div>
    <div class="columns is-multiline is-gapless">
      <div class="column is-12">
        <template v-if="data.isButton">
          <ValidationProvider
            :vid="`radiobuttontype${indexSection}${indexQuestion}`"
            name="Radio Button"
            :rules="`${data.isRequired ? 'required' : ''}`"
            v-slot="{ errors }"
          >
            <div class="columns is-gapless image-selector" :class="isMobile ? '' : 'is-multiline'" :style="isMobile ? 'display:flex; flex-wrap: wrap; row-gap: 6px;' : ''">
              <div
                v-for="(option, indexOption) in data.answerList"
                :key="indexOption"
                :class="option.type == 'text' ? 'column ' : ''"
                :style="(option.type == 'image' && isMobile) ? getMobileImageStyle()
                  : (option.type == 'text' && isMobile) ? 'flex: 1 1 100%;' : ''"
              >
                <template v-if="option.type == 'text' && !isMobile">
                  <b-radio-button class="notranslate"
                    :ref="'rdbtn_'+option.id"
                    type="is-hcc"
                    size="is-medium"
                    outlined
                    expanded
                    v-model="selectedOption"
                    :native-value="option.id"
                    @input="checkRulesRadioButton(option)"
                  >
                    {{ option.description }}
                  </b-radio-button>
                </template>
                <template v-if="option.type == 'text' && isMobile">
                  <b-radio-button class="notranslate text-options"
                    :ref="'rdbtn_'+option.id"
                    type="is-hcc"
                    size="is-medium"
                    outlined
                    expanded
                    style="height:100%;"
                    v-model="selectedOption"
                    :native-value="option.id"
                    @input="checkRulesRadioButton(option)"
                  >
                    {{ option.description }}
                  </b-radio-button>
                </template>
                <template v-else-if="option.type == 'image' && !isMobile">
                  <input
                    :ref="'rdbtn_'+option.id"
                    :id="option.id"
                    type="radio"
                    v-model="selectedOption"
                    :value="option.id"
                    @input="checkRulesRadioButton(option)"
                    v-show="false"
                  />
                  <label
                    class="my-radio-image"
                    :for="option.id"
                    style="
                      max-height: 190px;
                      max-width: 190px;
                      width: 190px;
                      height: 190px
                    "
                  >
                    <img
                      :id="`image-${option.id}`"
                      v-lazy="getUrlFile(option.imagePath)"
                      alt=""
                      style="width: 190px; height: 190px; object-fit: contain; padding: 5px;"
                    />
                  </label>
                </template>
                <template v-else-if="option.type == 'image' && isMobile">
                  <div class="image-options">
                    <input
                      :ref="'rdbtn_'+option.id"
                      :id="option.id"
                      type="radio"
                      v-model="selectedOption"
                      :value="option.id"
                      @input="checkRulesRadioButton(option)"
                      v-show="false"
                    />
                    <label
                      class="my-radio-image"
                      :for="option.id"
                      style="margin-left:0px; display:block; width:100%;"
                    >
                      <img
                        :id="`image-${option.id}`"
                        v-lazy="getUrlFile(option.imagePath)"
                        alt=""
                        style="width: 100%; height: auto; object-fit: contain; display:block;"
                      />
                    </label>
                  </div>
                </template>
              </div>
            </div>
            <span class="required">{{ errors[0] }}</span>
          </ValidationProvider>
        </template>
        <template v-else>
          <ValidationProvider
            :vid="`radiobuttontype${indexSection}${indexQuestion}`"
            name="Radio Button"
            :rules="`${data.isRequired ? 'required' : ''}`"
            v-slot="{ errors }"
          >
            <div :style="differentiateStyle(data.answerList)">
              <div
                v-for="(option, indexOption) in data.answerList"
                :key="indexOption"
              >
                <div class="columns">
                  <div class="column is-12 image-selector"
                  :class="option.type == 'image' && isMobile ? 'has-text-centered' : ''">
                    <template
                      v-if="option.type == 'text'"
                    >
                      <b-radio class="notranslate"
                        :ref="'rdbtn_'+option.id"
                        type="is-hcc"
                        v-model="selectedOption"
                        :native-value="option.id"
                        @input="checkRulesRadioButton(option)"
                      >
                        {{ option.description }}
                      </b-radio>
                    </template>
                    <template v-else-if="option.type == 'image' && !isMobile">
                      <b-radio
                        :ref="'rdbtn_'+option.id"
                        type="is-hcc"
                        v-model="selectedOption"
                        :native-value="option.id"
                        @input="checkRulesRadioButton(option)"
                      >
                        <img
                          v-lazy="getUrlFile(option.imagePath)"
                          alt="Image"
                          :style="
                            getSizeImage(option.id) >= 200
                              ? 'width: 200px;'
                              : 'width: auto;'
                          "
                        />
                      </b-radio>
                    </template>
                    <template v-else-if="option.type == 'image' && isMobile">
                      <img
                        v-lazy="getUrlFile(option.imagePath)"
                        alt="Image"
                        :style="
                          getSizeImage(option.id) >= 200
                            ? 'width: 200px;'
                            : 'width: auto;'
                        "
                      />
                      <b-radio
                        :ref="'rdbtn_'+option.id"
                        type="is-hcc"
                        v-model="selectedOption"
                        :native-value="option.id"
                        :style="option.type == 'image' ? 'margin-right: 0px !important;width:20px;' : ''"
                        @input="checkRulesRadioButton(option)"
                      ></b-radio>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <span class="required">{{ errors[0] }}</span>
          </ValidationProvider>
        </template>
        <info-storing-answer :question="data" @resend="$emit('resend-answer', data)"/>
      </div>
      <!-- For True Answer -->
      <template v-if="data.isExample && selectedOption">
        <div v-if="isAnswerTrue">
          <div :class="isMobile ? 'is-introduction' : ''" v-html="data.trueAnswer"></div>
        </div>
        <div v-else>
          <div :class="isMobile ? 'is-introduction' : ''" v-html="data.falseAnswer"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InfoStoringAnswer from '@/components/V2/Candidat/InfoStoringAnswer.vue'
export default {
  components:{
    InfoStoringAnswer,
  },
  props: {
    data: {
      default: () => {},
    },
    indexSection: {
      default: () => {},
    },
    indexQuestion: {
      default: () => {},
    },
    type: {
      default: () => {},
    },
    sectionId: {
      default: () => {},
    },
  },
  data() {
    return {
      selectedOption: null,
      isLoad: false,
      isAnswerTrue: false,
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  mounted() {
    this.init(this.data)
  },
  watch: {
    data(val){
      this.selectedOption = null
      this.isAnswerTrue = false

      this.init(val)
    },
    selectedOption(val) {
      if (!this.isLoad) {
        this.submit(val)
      } else {
        this.isLoad = false
      }
    },
  },
  methods: {
    getMobileImageStyle() {
      const totalImages = this.data.answerList.filter(o => o.type === 'image').length;
      if (totalImages <= 2) return 'width: 50%; box-sizing: border-box; flex: 0 0 25%;';
      if (totalImages <= 4) return 'width: 50%; box-sizing: border-box; flex: 0 0 25%;';
      return 'width: 33.333%; box-sizing: border-box; flex: 0 0 25%;';
    },
    init(data){
      this.isLoad = true
      data.answerList.map(answer => {
        if (answer.isAnswer) {
          this.selectedOption = answer.id
          this.isAnswerTrue = answer.isValid
        }
      })
      if (this.selectedOption == null) {
        this.isLoad = false
      }
    },
    submit(val) {
      let data = {
        newSectionId: this.sectionId,
        newQuestionId: this.data.id,
        newAnswerId: val,
        description: null,
        rating: 0,
        indexQuestion: 0,
        indexAnswer: 0,
      }

      this.$emit('clicked', data)
    },
    getUrlFile(file) {
      return process.env.VUE_APP_BACKEND_URL + file
    },
    getSizeImage(id) {
      let image = document.getElementById('image-' + id)

      if (image != null) {
        image = image.naturalWidth
      }

      return image
    },
    differentiateStyle(arr) {
      let type = arr[0].type
      if (type == 'image') {
        return 'display:flex'
      } else {
        return ''
      }
    },
    checkRulesRadioButton(option) {
      if (option.isValid) {
        this.isAnswerTrue = true
      } else {
        this.isAnswerTrue = false
      }
    },
    resetAnswer(){
      this.selectedOption = null
      this.data.answerList.forEach(option => {
        this.$refs['rdbtn_'+option.id][0].$el.children[0].checked = false
      })
    }
  },
}
</script>

<style>
.b-radio.radio.button.is-selected{
  z-index: unset;
}
.image-selector div input {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.image-selector div input:active + .my-radio-image {
  opacity: 0.9;
}
.image-selector div input:checked + .my-radio-image {
  -webkit-filter: none;
  -moz-filter: none;
  filter: none;
  outline: 5px solid #00a3a3;
  outline-offset: -4px;
  height: auto;
}

.b-radio.radio.is-medium {
  height: auto;
  font-size: 1.25rem;
  white-space: normal;
}

@media screen and (max-width: 768px) {
  .my-radio-image {
    box-sizing: border-box;
  }
  .b-radio.radio.is-medium {
    height: 100%;
  }
  .text-options * {
    font-size: 16px !important;
  }
  .image-selector div label {
    margin-left: 0px !important;
  }
}

.my-radio-image {
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  width: 100px;
  height: 70px;
  -webkit-transition: all 100ms ease-in;
  -moz-transition: all 100ms ease-in;
  transition: all 100ms ease-in;
  /* -webkit-filter: grayscale(1) opacity(0.7);
  -moz-filter: grayscale(1) opacity(0.7);
  filter: grayscale(1) opacity(0.7); */
}
/* @media screen and (min-width: 1216px) {
  .my-radio-image {
    height: 200px !important;
  }
}
@media screen and (min-width: 1408px) {
  .my-radio-image {
    height: 300px !important;
  }
} */
.my-radio-image:hover {
  /* -webkit-filter: grayscale(0.5) opacity(0.9);
  -moz-filter: grayscale(0.5) opacity(0.9);
  filter: grayscale(0.5) opacity(0.9); */
  outline: 5px solid #00a3a3;
  outline-offset: -4px;
  height: auto;
}

/* Extras */
a:visited {
  color: #888;
}
a {
  color: #444;
  text-decoration: none;
}
p {
  margin-bottom: 0.3em;
}

.image-selector div input {
  margin: 5px 0 0 12px;
}
.image-selector div label {
  margin-left: 7px;
}
span.cc {
  color: #6d84b4;
}
</style>
